import { v4 as uuidv4 } from 'uuid';

// Write opens on a blank document the clinician can type in (Cath, 2026-10-13).
// The document only becomes a real row in Files on its first autosave, so just
// opening Write never leaves empty "Untitled document" entries behind.

export const typedDocumentTitle = (date = new Date()) =>
  `Untitled document - ${date.toLocaleDateString('en-US', {
    timeZone: 'Asia/Taipei', month: 'short', day: '2-digit', year: 'numeric',
  })}`;

/** A not-yet-saved blank document, shaped like a Files entry of type Document. */
export function createTypedDocumentDraft(now = new Date()) {
  return {
    id: uuidv4(),
    type: 'Document',
    title: typedDocumentTitle(now),
    createdAt: now.toISOString(),
    originalData: { content: '' },
    isLocked: false,
    created: false,
  };
}

/**
 * Save the draft as a generatedreports row (the same table Generate writes to,
 * with no template and no source documents) and return its Files entry.
 * Throws on failure so the editor reports "could not be saved".
 */
export async function insertTypedDocument(client, { draft, patientId, userDetails }) {
  const now = new Date().toISOString();
  const { error } = await client.from('generatedreports').insert([{
    id: draft.id,
    patientId,
    consultationId: null,
    title: draft.title,
    content: '',
    locked: false,
    created_at: now,
    updated_at: now,
    created_by: userDetails?.name || 'Unknown User',
    created_by_user_id: userDetails?.id || null,
    documents: [],
    template_id: null,
  }]);
  if (error) throw error;
  return {
    id: draft.id,
    createdAt: now,
    title: draft.title,
    type: 'Document',
    originalData: { content: '', templateId: null },
    createdBy: userDetails?.name || 'Unknown User',
    isSelected: false,
    parentId: null,
    isSubItem: false,
    isLocked: false,
    isShared: false,
    documents: [],
  };
}
